import React, { Fragment } from 'react'

export default function AboutEN(props) {
  return (
    <Fragment>
      <div className="about">
        <div className="about-block">
          <div className="about-lines">
            <span className="about-lines__green" />
            <span className="about-lines__white" />
            <span className="about-lines__gray" />
          </div>

          <div className="about-block-right">
            <div className="about-block-text">
              <p className="_intro">
                يشهد المشهد الإعلامي العالمي تغيراً سريعاً نظراً لانتشار الأخبار
                في كل مكان وتحوّل تركيز القصص الإخبارية ومكانها باستمرار وتطوّر
                الروايات في زمن قياسي.
              </p>
              <p>
                أدى هذا التحرّك نحو عالم متعدد الأقطاب إلى إعادة تركيز جدول
                الأعمال وترتيب أولوياته – وبات إيجاد زوايا فريدة والحاجة الماسّة
                إلى التنوع والاختلاف وتقديم تفاصيل حاسمة وسياق أساسي أمراً يزداد
                صعوبة.
              </p>
              <p>
                تسعى وكالة "فيوري" جاهدةً لأن تصبح مصدراً موثوقاً للقصص
                الإخبارية الرئيسية من منطقة الجنوب العالمي ودول منظمة بريكس لكي
                تكون منبراً لأصواتهم على الصعيد العالمي.
              </p>

              <p>
                تتمثل مهمتنا في تمكين عملائنا من سرد قصتهم الكاملة وتقديم محتوى
                حصري لهم.
              </p>
              <p>
                نحرص على تقديم مواد فريدة لجميع العاملين في مجال الإعلام، من
                التجمّعات الدولية إلى الوسائل الإعلامية الإقليمية والصحفيين
                المستقلين – إلى جانب الصورة الكاملة للشؤون الدولية والإقليمية
                إلى جمهورهم.
              </p>
              <p>
                تعمل "فيوري" مع شبكة مكونة من آلاف الصحفيين المصوّرين المتواجدين
                في مواقع الحدث، والذين يقدمون مقاطع فيديو من لحظة وقوع الحدث ومن
                أكثر المناطق التي يصعب الوصول إليها.
              </p>
              <p>
                إن وصولنا الحصري يعني أننا نسير بخطى ثابتة وسريعة لنصبح أول
                مؤسسة – وغالباً الوحيدة – التي تغطي أكبر القصص الإخبارية
                العالمية.
              </p>
              <p>
                وتحقيقاً لهذه الغاية، نستخدم منتجات وأنظمة داخلية مخصصة صممناها
                خصيصاً للفيديوهات الإخبارية الواردة من أي مصدر كان، بحيث يكون
                عملاؤنا على ثقة بأنه تم التحقق من صحة المواد المُقدّمة لهم بغض
                النظر عن مصدرها.
              </p>
              <p>
                كما نعتمد – لهذا الغاية – على تقنيات متقدمة لإنتاج المحتوى
                الإخباري وتقديمه بغية توفير فيديوهات إخبارية مثبتة وذات جودة
                عالية وفورية.
              </p>
              <p>
                إن تحقيق أهدافنا يأتي بفضل طاقمنا الإخباري الذي يتميز بالكفاءة
                والمهارة، وفريقنا المشهود له بالمرونة والشجاعة والسرعة والنشاط
                تدعمها خبرة عقود في العمل الميداني، جميعهم يعملون معاً بسلاسة
                لتقديم خدماتهم لعملائنا بشكل متواصل.
              </p>
              <p>
                في وكالتنا، ندرك أن القصة الكاملة غالباً ما تكون متعددة الأوجه –
                وهدفنا هو إتاحة العناصر الحيوية للجميع.
              </p>
              <p>فيوري.</p>
              <p className="_intro">إذا أردت معرفة القصة الكاملة.</p>
            </div>
          </div>
        </div>
      </div>
    </Fragment>
  )
}
